import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtodavangeretaxi() {



    const cardData = {




keyword: "Belgaum to Davangere Taxi",

headingDescription: "Belgaum Taxi Service provides safe, reliable, and affordable Belgaum to Davangere taxi services for business travel, family vacations, corporate tours, medical visits, educational trips, and outstation journeys across Karnataka. Whether you need a one-way taxi or a round-trip cab from Belgaum to Davangere, we offer comfortable travel with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium vehicles suitable for solo travelers, families, corporate executives, and groups. We offer doorstep pickup and drop, flexible travel schedules, transparent pricing without hidden charges, easy online booking, and 24/7 customer support to make your journey convenient and stress-free. Belgaum Taxi Service is trusted by customers for timely service, clean vehicles, courteous drivers, and a smooth travel experience. Whether you are traveling for business meetings, industrial visits, college admissions, family functions, sightseeing, or personal work, our Belgaum to Davangere taxi service ensures a safe, comfortable, and enjoyable ride throughout your journey with the highest standards of customer satisfaction.",

topPlaces: [
  {
    title: "Davangere",
    description: "Davangere is one of Karnataka's fastest-growing commercial cities, known for educational institutions, textile businesses, industries, and the famous Davangere Benne Dosa."
  },
  {
    title: "Kunduvada Kere",
    description: "Kunduvada Kere is a beautiful lake in Davangere offering peaceful surroundings, walking tracks, birdwatching opportunities, and relaxing evening views."
  },
  {
    title: "Apoorva Resort",
    description: "Apoorva Resort is a popular leisure destination near Davangere where families and groups enjoy weekend outings, events, and recreational activities."
  },
  {
    title: "Harihar",
    description: "Harihar is a nearby town famous for the ancient Harihareshwara Temple and its historical significance, making it a popular stop for pilgrims and tourists."
  },
  {
    title: "Chitradurga",
    description: "Chitradurga is well known for the magnificent Chitradurga Fort, historical monuments, and scenic rocky landscapes, attracting visitors throughout the year."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for its ancient temples, stone monuments, royal structures, and the rich heritage of the Vijayanagara Empire."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial city in North Karnataka known for business centers, shopping markets, hospitals, educational institutions, and excellent road connectivity."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's leading IT and corporate hub with technology parks, multinational companies, shopping malls, entertainment centers, and excellent business opportunities."
  },
  {
    title: "Mysore",
    description: "Mysore is a famous heritage city known for Mysore Palace, Chamundi Hills, Brindavan Gardens, museums, and its rich royal culture."
  },
  {
    title: "Goa",
    description: "Goa is one of India's most popular beach destinations, famous for its scenic coastline, luxury resorts, churches, nightlife, water sports, and family holiday experiences."
  }
],




"services": [
  {
    "name": "Belgaum to Davangere Taxi",
    "description": "Book Belgaum to Davangere Taxi for safe, comfortable, and reliable intercity travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, airport transfers, and outstation journeys with affordable pricing and flexible booking options."
  },
  {
    "name": "Belgaum to Davangere Cab",
    "description": "Hire Belgaum to Davangere Cab for convenient transportation with professional drivers, sanitized vehicles, and transparent fares. Enjoy a smooth travel experience for personal, family, corporate, and long-distance journeys with one way and round trip options."
  },
  {
    "name": "Belgaum to Davangere Taxi Service",
    "description": "Choose Belgaum to Davangere Taxi Service for dependable travel with punctual pickups, comfortable seating, and courteous chauffeurs. Our taxi service is ideal for business meetings, holiday trips, family vacations, and regular outstation travel."
  },
  {
    "name": "Belgaum to Davangere Cab Service",
    "description": "Book Belgaum to Davangere Cab Service with reliable drivers and premium vehicles for a safe and comfortable journey. We provide affordable cab services with flexible schedules and quality customer support."
  },
  {
    "name": "Belgaum to Davangere One Way Cab",
    "description": "Reserve Belgaum to Davangere One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable AC vehicles, and experienced chauffeurs for hassle-free transportation."
  },
  {
    "name": "Belgaum to Davangere One Way Taxi",
    "description": "Choose Belgaum to Davangere One Way Taxi for budget-friendly travel with quick booking, reliable service, and professional drivers. Travel comfortably without paying unnecessary return fares."
  },
  {
    "name": "Belgaum to Davangere Cab Booking",
    "description": "Complete Belgaum to Davangere Cab Booking with easy online reservations, instant confirmation, and multiple vehicle options. Select the ideal cab based on your travel requirements and passenger capacity."
  },
  {
    "name": "Belgaum to Davangere Taxi Booking",
    "description": "Book Belgaum to Davangere Taxi Booking for convenient travel with affordable rates, experienced chauffeurs, and comfortable vehicles. Enjoy a seamless booking process and reliable transportation."
  },
  {
    "name": "Belgaum to Davangere Car Rental",
    "description": "Hire Belgaum to Davangere Car Rental with driver for flexible travel plans. Our rental service is perfect for family outings, business visits, sightseeing tours, airport transfers, and long-distance travel."
  },
  {
    "name": "Belgaum to Davangere Outstation Cab",
    "description": "Travel with Belgaum to Davangere Outstation Cab offering comfortable long-distance transportation with experienced drivers, AC vehicles, and affordable one way or round trip packages."
  },
  {
    "name": "Belgaum to Davangere Innova Crysta Cab",
    "description": "Book Belgaum to Davangere Innova Crysta Cab for premium travel with spacious seating, luxurious interiors, and ample luggage capacity. Ideal for family vacations, corporate executives, and group travel."
  },
  {
    "name": "Belgaum to Davangere Ertiga Cab",
    "description": "Choose Belgaum to Davangere Ertiga Cab for comfortable 6 to 7 seater travel with affordable pricing and experienced chauffeurs. Perfect for family trips, airport transfers, and business travel."
  },
  {
    "name": "Belgaum to Davangere Sedan Cab",
    "description": "Book Belgaum to Davangere Sedan Cab for economical and comfortable travel with clean AC cars, skilled drivers, and reliable transportation suitable for business and personal journeys."
  },
  {
    "name": "Belgaum to Davangere Round Trip Cab",
    "description": "Reserve Belgaum to Davangere Round Trip Cab for convenient return travel with flexible schedules, affordable packages, and comfortable vehicles driven by experienced chauffeurs."
  },
  {
    "name": "Belgaum to Davangere Private Taxi",
    "description": "Hire Belgaum to Davangere Private Taxi for exclusive travel with dedicated vehicles, personalized service, and professional drivers. Enjoy complete privacy and flexible travel timings."
  },
  {
    "name": "Cheap Belgaum to Davangere Taxi",
    "description": "Find Cheap Belgaum to Davangere Taxi services offering affordable fares, quality vehicles, and dependable drivers. Enjoy budget-friendly transportation without compromising comfort or safety."
  },
  {
    "name": "Best Belgaum to Davangere Taxi Service",
    "description": "Choose the Best Belgaum to Davangere Taxi Service with premium vehicles, professional chauffeurs, transparent pricing, and dependable travel solutions for families, individuals, and businesses."
  },
  {
    "name": "Online Belgaum to Davangere Cab Booking",
    "description": "Book Online Belgaum to Davangere Cab Booking with instant confirmation, flexible pickup locations, and multiple cab options. Plan your journey easily with reliable online reservation facilities."
  },
  {
    "name": "Belgaum to Davangere Taxi Fare",
    "description": "Get affordable Belgaum to Davangere Taxi Fare with transparent pricing, competitive rates, and multiple vehicle choices. Select the right cab according to your travel budget and comfort."
  },
  {
    "name": "Belgaum to Davangere Car Hire",
    "description": "Hire Belgaum to Davangere Car Hire services with professional chauffeurs and well-maintained vehicles. Suitable for business travel, family vacations, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Davangere Cab Price",
    "description": "Check Belgaum to Davangere Cab Price and choose from affordable Sedan, Ertiga, Innova Crysta, and SUV options with flexible booking and excellent travel comfort."
  },
  {
    "name": "Belgaum to Davangere Family Cab",
    "description": "Book Belgaum to Davangere Family Cab for spacious and comfortable travel with experienced drivers. Perfect for family vacations, functions, holidays, and weekend trips."
  },
  {
    "name": "Belgaum to Davangere Corporate Taxi",
    "description": "Choose Belgaum to Davangere Corporate Taxi for executive travel with punctual pickups, premium vehicles, and professional chauffeurs. Ideal for meetings, office travel, and corporate transportation."
  },
  {
    "name": "Belgaum to Davangere Airport Transfer",
    "description": "Book Belgaum to Davangere Airport Transfer for timely airport pickup and drop services with reliable drivers, comfortable AC vehicles, and convenient travel arrangements."
  },
  {
    "name": "Belgaum to Davangere Cab Fare",
    "description": "Get complete information about Belgaum to Davangere Cab Fare with transparent pricing, affordable packages, and multiple vehicle options for one way and round trip travel."
  },
  {
    "name": "Belgaum to Davangere Taxi Near Me",
    "description": "Find Belgaum to Davangere Taxi Near Me for quick cab availability with experienced chauffeurs, clean vehicles, and reliable customer support for safe and comfortable travel."
  },
  {
    "name": "Belgaum to Davangere Outstation Taxi",
    "description": "Hire Belgaum to Davangere Outstation Taxi for dependable long-distance travel with comfortable AC vehicles, professional drivers, and flexible booking options for every journey."
  },
  {
    "name": "Belgaum to Davangere Travel by Cab",
    "description": "Travel from Belgaum to Davangere by Cab with safe, reliable, and comfortable transportation. Enjoy experienced chauffeurs, premium vehicles, flexible schedules, and a stress-free journey for business, family, or leisure travel."
  }
],
"tableData": [
  ["Belgaum to Davangere Taxi", "Belgaum to Davangere Cab"],
  ["Belgaum to Davangere Taxi Service", "Belgaum to Davangere Cab Service"],
  ["Belgaum to Davangere One Way Cab", "Belgaum to Davangere One Way Taxi"],
  ["Belgaum to Davangere Cab Booking", "Belgaum to Davangere Taxi Booking"],
  ["Belgaum to Davangere Car Rental", "Belgaum to Davangere Outstation Cab"],
  ["Belgaum to Davangere Innova Crysta Cab", "Belgaum to Davangere Ertiga Cab"],
  ["Belgaum to Davangere Sedan Cab", "Belgaum to Davangere Round Trip Cab"],
  ["Belgaum to Davangere Private Taxi", "Cheap Belgaum to Davangere Taxi"],
  ["Best Belgaum to Davangere Taxi Service", "Online Belgaum to Davangere Cab Booking"],
  ["Belgaum to Davangere Taxi Fare", "Belgaum to Davangere Car Hire"],
  ["Belgaum to Davangere Cab Price", "Belgaum to Davangere Family Cab"],
  ["Belgaum to Davangere Corporate Taxi", "Belgaum to Davangere Airport Transfer"],
  ["Belgaum to Davangere Cab Fare", "Belgaum to Davangere Taxi Near Me"],
  ["Belgaum to Davangere Outstation Taxi", "Belgaum to Davangere Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Trusted Belgaum to Davangere Taxi Service",
    WhyChoosedescription: "Travel confidently from Belgaum to Davangere with comfortable cabs, courteous chauffeurs, and reliable transportation designed for long-distance journeys across Karnataka."
  },
  {
    WhyChooseheading: "Travel on Your Own Schedule",
    WhyChoosedescription: "Forget fixed bus or train timings. Choose your preferred departure time and enjoy a private taxi that travels according to your convenience."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle",
    WhyChoosedescription: "Book a Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, or SUV based on the number of passengers and luggage for a comfortable road trip."
  },
  {
    WhyChooseheading: "Ideal for Every Travel Purpose",
    WhyChoosedescription: "Whether you're travelling for business meetings, family functions, educational visits, medical appointments, or holidays, our taxi service offers a practical travel solution."
  },
  {
    WhyChooseheading: "Safe Highway Driving Experience",
    WhyChoosedescription: "Our trained drivers follow safe driving practices, know the best routes, and focus on providing a smooth and pleasant travel experience."
  },
  {
    WhyChooseheading: "One-Way, Round Trip & Multi-Day Booking",
    WhyChoosedescription: "Plan your journey the way you want with flexible booking options including one-way travel, return cabs, and customized multi-day trips."
  },
  {
    WhyChooseheading: "Well-Maintained & Hygienic Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, cleaned before trips, and equipped to provide a relaxing journey for both short and long-distance travel."
  },
  {
    WhyChooseheading: "Instant Booking Assistance",
    WhyChoosedescription: "Our team helps you with fare enquiries, vehicle recommendations, and quick booking confirmation to make your Belgaum to Davangere trip hassle-free."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Davangere Taxi Service?",
    answer: "Yes, we provide private taxi services from Belgaum to Davangere with comfortable vehicles and experienced drivers."
  },
  {
    question: "Can I reserve a one-way taxi from Belgaum to Davangere?",
    answer: "Yes, one-way cab bookings are available along with round-trip and customized travel packages."
  },
  {
    question: "Which vehicles can I book for this route?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, and other premium vehicles."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickups are available from Belgaum Airport, Railway Station, hotels, residences, offices, and other preferred locations."
  },
  {
    question: "Is this taxi service suitable for corporate travel?",
    answer: "Yes, many business travellers choose our Belgaum to Davangere taxi service for meetings, site visits, and official travel."
  },
  {
    question: "Can families book larger vehicles for this journey?",
    answer: "Certainly. Spacious vehicles like Ertiga, Innova, and Innova Crysta are available for families and groups."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable expenses are generally informed during booking based on your travel package."
  },
  {
    question: "Is the taxi available throughout the day?",
    answer: "Yes, our Belgaum to Davangere cab service is available 24/7 with advance and same-day booking support."
  },
  {
    question: "Can I customize my travel route with stops?",
    answer: "Yes, additional stopovers can be arranged based on your itinerary and travel requirements."
  },
  {
    question: "How do I book a Belgaum to Davangere Taxi?",
    answer: "Simply share your pickup location, travel date, destination, passenger count, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback: "I booked this taxi for a business visit to Davangere, and the service exceeded my expectations. The vehicle was comfortable, and the driver maintained excellent professionalism throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Lakshmi Rao",
    feedback: "Our family travelled to Davangere in an Innova Crysta, and the trip was enjoyable from start to finish. Clean vehicle, courteous driver, and a very smooth ride.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Davangere Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-davangere-taxi.webp",
  "description":
    "Book Belgaum to Davangere Taxi with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Davangere with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-davangere-taxi"
  }
};






    return (
        <div>

<Helmet>
  <title>Belgaum to Davangere Taxi | One Way Cab Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Davangere Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Davangere with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Davangere Taxi, Belgaum to Davangere Cab, Belgaum to Davangere Taxi Service, Belgaum to Davangere Cab Service, Belgaum to Davangere One Way Cab, Belgaum to Davangere One Way Taxi, Belgaum to Davangere Cab Booking, Belgaum to Davangere Taxi Booking, Belgaum to Davangere Car Rental, Belgaum to Davangere Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtodavangeretaxi;